import { createContext, useContext, type ReactNode } from 'react'

export type ToastTone = 'info' | 'success' | 'warn' | 'error'

export interface ToastInput {
  title: ReactNode
  description?: ReactNode
  tone?: ToastTone
  /** ms; 0 keeps it until dismissed. Default 4000 (errors 7000). */
  duration?: number
  action?: { label: string; onClick: () => void }
}

export interface ToastApi {
  show: (t: ToastInput) => string
  dismiss: (id: string) => void
  success: (title: ReactNode, description?: ReactNode) => string
  error: (title: ReactNode, description?: ReactNode) => string
}

export const ToastContext = createContext<ToastApi | null>(null)

export function useToast(): ToastApi {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used inside <ToastProvider>')
  return ctx
}
